(function () {
    'use strict';

    angular
        .module('iqxCore')
        .service('initSessionSvc', initSessionSvc)

    function initSessionSvc(ApiSvc, ApplicationSvc, $http, $cookies, $window, loginSvc, menuSvc, $location, pinSvc, inactivitySvc, socketSvc, serviceWorkerSvc, SweetAlert, $timeout, BehaviourSvc) {
        var svc = this
        svc.update = update
        svc.isCookie = true
        Promise.all([
            BehaviourSvc.get()
        ])
            .then(getParams)
            .then(serviceWorkerSvc.installOrUpdate)
            .then(inactivitySvc.enable)


        if ($location.path() !== '/login') {
            init()
        }

        function init() {
            var tempSess = $cookies.getObject('IQXSession')
            var behaviourCookie = $cookies.getObject('IQXBehaviour')
            var IQXToken = $window.sessionStorage.getItem('IQXToken')
            var needsReAuth = false
            if (!tempSess) {
                tempSess = $window.sessionStorage.getItem('IQXSession')
                svc.isCookie = false
            }

            if (tempSess) {
                ApplicationSvc.currentUser = angular.fromJson(tempSess)
                if (behaviourCookie) {
                    ApplicationSvc.params.behaviour = angular.fromJson(behaviourCookie)
                }
                menuSvc.update()
                ApplicationSvc.isLoggedIn = true


                if (ApplicationSvc.currentUser.pinauth === true) {
                    // the cookie/session is scrambled!
                    if (IQXToken) {
                        // We have a session token with the unscrambled stuffs!
                        $http.defaults.headers.common['X-Auth'] = IQXToken
                        inactivitySvc.callBack = function () {
                            inactivitySvc.disable()
                            pinSvc.lock(true)
                        }
                    } else {
                        needsReAuth = true
                        if ($location.path !== '/register' || $location.path !== '/register/perm') {
                            $location.path('/pin')
                        } else {
                            loginSvc.setLoggedOut()
                        }
                        if ($location.path() != '/pin') {
                            $location.path('/pin')
                        }
                    }
                } else {
                    // continue as normal
                    $http.defaults.headers.common['X-Auth'] = ApplicationSvc.currentUser.token
                    inactivitySvc.callBack = loginSvc.setLoggedOut

                    var userAgent = window.navigator.userAgent.toLowerCase()
                    var safari = /zzzsafari/.test(userAgent)
                    var ios = /iphone|ipod|ipad/.test(userAgent)

                    if (ios) {
                        if (!safari) {
                            serviceWorkerSvc.registerPush()
                        }
                    } else {
                        if ($cookies.get('pushPermissions') === 1) {
                            serviceWorkerSvc.registerPush()
                        }
                    }
                }
                if (needsReAuth === false) { update() }

                if (ApplicationSvc.currentUser.Switches.indexOf('PINAUTHALLOW') !== -1 && ApplicationSvc.currentUser.Switches.indexOf('PINAUTHFORCE') !== -1 && ApplicationSvc.currentUser.pinauth !== true) {
                    $location.url('/settings?createPIN=true&continue=' + pinSvc.setPage)
                }
            }
        }

        function getParams() {
            return $http.get('/api/auth/params')
                .then(function (res) {
                    ApplicationSvc.params = angular.merge(ApplicationSvc.params, ApplicationSvc.params, res.data)
                })
                .then(function () {
                    $http.get('/api/auth/lang')
                        .then(function (res) {
                            ApplicationSvc.params.lang = angular.merge(ApplicationSvc.params.lang, ApplicationSvc.params.lang, res.data)
                        })
                })
                .then(function () {
                    if (ApplicationSvc.params.SHOWNEWVERSIONWARN && ApplicationSvc.params.docker !== true) {
                        socketSvc.connect()
                    }
                })
                .then(function () {
                    if (ApplicationSvc.params.version) {
                        console.info('iqxWEB', ApplicationSvc.params.version)
                    }
                })
                .then(function () {
                    if (ApplicationSvc.params.GOOGLEANALYTICS) {
                        var g_tag = document.createElement('script')
                        g_tag.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + ApplicationSvc.params.GOOGLEANALYTICS)
                        document.head.appendChild(g_tag)
                        window.dataLayer = window.dataLayer || []
                        function gtag() { dataLayer.push(arguments) }
                        gtag('js', new Date())
                        gtag('config', ApplicationSvc.params.GOOGLEANALYTICS)
                    }
                })
        }

        function update() {
            var fetchScope = {}
            return ApiSvc.fetch(fetchScope, { fetchAPI: 'callresult/NetUpdatePermissions', fetchTarget: 'x', fetchWithPersonID: true })
                .then(function () {
                    if (fetchScope.x.State === '.') {
                        return SweetAlert.swal({
                            title: 'Your account has been disabled',
                            text: 'For more information, please contact us.',
                            type: 'info'
                        })
                            .then(function () {
                                $timeout(function () {
                                    loginSvc.setLoggedOut()
                                    if (ApplicationSvc.isApp !== true) {
                                        $location.path('/login')
                                    } else {
                                        window.location.href = "/login"
                                    }
                                })

                            })
                    }
                    if (fetchScope.x.MarkedForDeletion > 0){
                        ApplicationSvc.currentUser.markedForDeletion = true
                    }
                    ApplicationSvc.currentUser.UserRights = fetchScope.x.Rights.split(',')
                    ApplicationSvc.currentUser.Switches = fetchScope.x.Switches.split(',')

                    if (ApplicationSvc.currentUser.UserRights.indexOf('LOGIN') === -1) {
                        $location.url('/noPermission')
                        loginSvc.setLoggedOut()
                    } else {
                        menuSvc.update()
                        if (ApplicationSvc.currentUser.UserClass === "CANDIDATE") {
                            return ApiSvc.fetch(fetchScope, {
                                fetchAPI: 'callresult/NetCandidateRegDetails?pPersonID=' + (ApplicationSvc.currentUser.personID || ''),
                                fetchTarget: 'regDets',
                                multiRow: false,
                                booleanFields: ['DepartmentPerm', 'DepartmentTemp']
                            })
                                .then(function () {
                                    ApplicationSvc.currentUser.registrationDetails = fetchScope.regDets
                                })
                        } else if (ApplicationSvc.currentUser.UserClass === "CLIENT") {
                            return ApiSvc.fetch(fetchScope, {
                                fetchAPI: 'callresult/NetClientDivision',
                                fetchTarget: 'clientDivID',
                                multiRow: false,
                                booleanFields: ['DepartmentPerm', 'DepartmentTemp']
                            })
                                .then(function () {
                                    ApplicationSvc.currentUser.divisionid = fetchScope.clientDivID.divisionid
                                })
                        }

                        if (svc.isCookie) {
                            $cookies.putObject('IQXSession', ApplicationSvc.currentUser, ApplicationSvc.cookieOptions)
                        } else {
                            $window.sessionStorage.setItem('IQXSession', JSON.stringify(ApplicationSvc.currentUser))
                        }
                    }
                })
                .then(BehaviourSvc.get)
                .then(function () {
                    var behaviourCookie = $cookies.getObject('IQXBehaviour')
                    ApplicationSvc.params.behaviour = angular.fromJson(behaviourCookie)
                })
        }
    }
})()